/**
 * Représentation d'une réponse d'erreur ProblemDetails (RFC 9457)
 * telle que renvoyée par GlobalExceptionFilter.cs
 */
export interface ProblemDetails {
  type?: string
  title?: string
  status?: number
  detail?: string
  instance?: string
  [key: string]: unknown
}

/**
 * Erreur générée par l'API Altazion Commerce (HTTP 4xx / 5xx).
 */
export class AltazionApiError extends Error {
  readonly status: number
  readonly problem: ProblemDetails

  constructor(status: number, problem: ProblemDetails) {
    super(problem.detail ?? problem.title ?? `HTTP ${status}`)
    this.name = 'AltazionApiError'
    this.status = status
    this.problem = problem
  }
}

/**
 * Erreur levée lorsque le SDK est hors-ligne et ne peut pas
 * satisfaire la requête depuis le cache.
 */
export class OfflineError extends Error {
  constructor(message = 'Le SDK est hors-ligne et aucun cache n\'est disponible pour cette ressource') {
    super(message)
    this.name = 'OfflineError'
  }
}

/**
 * Erreur liée à une opération sur le cache (IndexedDB, SharedWorker).
 */
export class CacheError extends Error {
  readonly cause: unknown

  constructor(message: string, cause?: unknown) {
    super(message)
    this.name = 'CacheError'
    this.cause = cause
  }
}
